import { isProd, isStaging } from "@/constants/";

export const getSrc = (src: string): string => (isProd || isStaging ? process.env.NEXT_PUBLIC_CDN_URL : "") + src;
